module.exports = __webpack_public_path__ + "img/ocr4.79845a12.png";